import {DotPath} from '../getOrElse'
import {getDefinedOrElse} from './getter'
import {Decorators} from '../config/getterConfig'
import {decorate} from './decorator'

export function booleanOr<R extends any, T extends boolean>(
  root: R,
  path: DotPath = '',
  decorators: Decorators<boolean> = [],
  orElse = false as T
): T {
  const raw = Boolean(getDefinedOrElse(root, path, orElse) as T)
  return decorate(raw, decorators) as T
}
